import React, { useEffect } from 'react';
import { Form, Col, Row, Card } from 'antd';
import { FormInstance } from 'antd/lib/form';
import Title from 'antd/lib/typography/Title';
import {
  PhoneOutlined,
  MobileOutlined,
  MailOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import ModalSFS from '../../../../../../components/theme_components/ModalSFS';
import ContactModal from './ContactModal';
import { deleteThirdPartyContactByid, tpContactsResponse } from 'services/thirdParty';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Notification from 'components/theme_components/Notifications';

export type ContactCardProps = {
  contact: tpContactsResponse;
  tpid: number;
  refetch?: () => void;
  index?: number;
  hideDeletebtn: boolean;
};

const ContactCard = ({ contact, tpid, refetch, index, hideDeletebtn }: ContactCardProps) => {
  const [form] = useForm();
  const fieldName = 'listContacts';
  useEffect(() => {
    if (contact) {
      form.setFieldsValue({ [fieldName]: contact });
    } else {
      form.setFieldsValue({ [fieldName]: [] });
    }
  }, [form, contact]);

  return (
    <Form form={form}>
      <Card
        className="activity-card"
        style={{
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          position: 'relative',
        }}
      >
        <Row gutter={[16, 16]} justify="space-between">
          <Col span={20} className="pb-20">
            <Title level={2} className=" mb-0">
              {contact?.firstname}{' '}
              {contact?.lastname}
            </Title>
            <span className="font-size-20 gray-color">
              {contact?.position}
            </span>
          </Col>

          <Col span={2} style={{
            display: 'flex',
            justifyContent: "flex-end",
            alignItems: " flex-start",
            marginTop: "11px",
          }}>
            {' '}
            {!hideDeletebtn && <DeleteOutlined className="color-orange font-size-25" onClick={() => {
              deleteThirdPartyContactByid({
                tpid: contact.tpid, tpcontactid: contact.tpcontactid,
              }).then((res) => {
                Notification({
                  status: "success",
                  message: res.message,
                  description: res.description,
                  duration: 30,
                  placement: 'topRight',
                  confirm:true
                });
                refetch && refetch();

              });
            }} />}

            <ModalSFS
              trigger={({ setVisible }) => (
                <EditOutlined
                  className="color-orange font-size-25 floatRight"
                  style={{ marginLeft: 5 }}
                  onClick={() => setVisible(true)}
                />
              )}
              title={'Modification du contact ' + Number(index)}
            >
              <ContactModal
                tpid={tpid}
                contacts={contact}
                setVisible={() => false}
                refetch={refetch}
              />
            </ModalSFS>
          </Col>


        </Row>
        <Row gutter={8}>
          <Col span={1} className=" align-content-center">
            <PhoneOutlined className="font-size-30 gray-color  rotation " />
          </Col>
          <Col span={7} >
            <p className="font-size-18 gray-color">
              <GetLabel label="Téléphone fixe" />
            </p>
            <p className="font-size-20">{contact.tel1}</p>
          </Col>

          <Col span={1} className=" align-content-center">
            <MobileOutlined className="font-size-30 gray-color align-center floatLeft" />
          </Col>
          <Col span={7}>

            <p className="font-size-18 gray-color">
              <GetLabel label="Téléphone portable" />
            </p>
            <p className="font-size-20">
              {contact.tel2}
            </p>

          </Col>
          <Col span={1} className=" align-content-center">
            <MailOutlined className="font-size-30 gray-color align-center floatLeft" />
          </Col>
          <Col span={7}>

            <p className="font-size-18 gray-color ">
              <GetLabel label="Mail" />
            </p>
            <p className="font-size-20">{contact.email}</p>

          </Col>
        </Row>
      </Card>
    </Form >
  );
};

export default ContactCard;
